var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlantPotAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1668 12C13.1668 12.6627 12.6444 13.2 12.0001 13.2C11.3558 13.2 10.8334 12.6627 10.8334 12C10.8334 11.3373 11.3558 10.8 12.0001 10.8C12.6444 10.8 13.1668 11.3373 13.1668 12Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 6.16667V7.33333C2 7.97766 2.55964 8.5 3.25 8.5H4.5L5.62645 17.9622C5.69679 18.553 6.23187 19 6.8688 19H17.1312C17.7681 19 18.3032 18.553 18.3736 17.9622L19.5 8.5H20.75C21.4404 8.5 22 7.97767 22 7.33333V6.16667C22 5.52233 21.4404 5 20.75 5H3.25C2.55964 5 2 5.52233 2 6.16667ZM12 8C12.8077 8 13.434 8.7334 13.3448 9.56854C13.9929 9.07023 14.9145 9.26973 15.3184 9.99996C15.7222 10.7302 15.4269 11.6631 14.6894 12C15.4269 12.3369 15.7222 13.2698 15.3183 14C14.9145 14.7302 13.9929 14.9297 13.3448 14.4315C13.434 15.2666 12.8077 16 12 16C11.1924 16 10.5661 15.2666 10.6553 14.4315C10.0071 14.9297 9.08563 14.7302 8.6818 14C8.27796 13.2698 8.57323 12.3369 9.31068 12C8.57323 11.6631 8.27794 10.7302 8.68179 9.99998C9.08562 9.26979 10.0071 9.07027 10.6553 9.56849C10.5661 8.73337 11.1924 8 12 8Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlantPotAlt);
export default __webpack_public_path__ + "static/media/plant-pot-alt.e6fbdf3830c99ffe292cf1a310915cb8.svg";
export { ForwardRef as ReactComponent };